import React from 'react'
import './sass/Faq.scss'

const Faq = () => {
    return (
        <div className="faq">
            <h2>FAQ</h2>
            <div className="faq-content">
                <div className="left-content">
                    <div className="question-container">
                        <span className="question">Do you provide International delivery?</span>
                        <p>I'm a paragraph. Click here to add your own text and edit me. It’s easy. Just click “Edit Text” or double click me to add your own content and make changes to the font.</p>
                    </div>
                    <div className="question-container">
                        <span className="question">How do I return an item?</span>
                        <p>I'm a paragraph. Click here to add your own text and edit me. It’s easy. Just click “Edit Text” or double click me to add your own content and make changes to the font.</p>
                    </div>
                    <div className="question-container">
                        <span className="question">What is your returns policy?</span>
                        <p>I'm a paragraph. Click here to add your own text and edit me. It’s easy. Just click “Edit Text” or double click me to add your own content and make changes to the font.</p>
                    </div>
                </div>
                <div className="right-content">
                    <div className="question-container">
                        <span className="question">How do I track my order?</span>
                        <p>I'm a paragraph. Click here to add your own text and edit me. It’s easy. Just click “Edit Text” or double click me to add your own content and make changes to the font.</p>
                    </div>
                    <div className="question-container">
                        <span className="question">How can I contact your couriers?</span>
                        <p>I'm a paragraph. Click here to add your own text and edit me. It’s easy. Just click “Edit Text” or double click me to add your own content and make changes to the font.</p>
                    </div>
                    <div className="question-container">
                        <span className="question">What are your delivery options?</span>
                        <p>I'm a paragraph. Click here to add your own text and edit me. It’s easy. Just click “Edit Text” or double click me to add your own content and make changes to the font.</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Faq
